// Header

$(document).ready(function() {
        var elem = $('.nav-logo-item');
        var scroll = $(window).scrollTop();
        if (scroll > 10) {
            elem.show();
            if ($(window).width() < 1280)  {
              $('.header-logo').css('display', 'inline-block');
            }
        } else if (scroll <= 10) {
            elem.hide();
            if ($(window).width() < 1280)  {
              $('.header-logo').hide();
            }
        }
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            $('.nav-logo-item').removeClass('force_none');
            if (scroll > 10) {
              if ($(window).width() >= 1280) {
                setTimeout(function() { 
                    $('.nav-menu').fadeIn();
                    $('.nav-logo-item').fadeIn();
                    $('.header-logo').show();
                }, 570);
              } else {
                $('.header-logo').css('display', 'inline-block');
              }
            } else {
              if ($(window).width() >= 1280) {
                $('.nav-logo-item').hide();
                $('.nav-logo-item').addClass('force_none');
                $('.nav-menu').hide();
                setTimeout(function() { 
                    $('.nav-menu').fadeIn();
                }, 570);
              } else {
                $('.header-logo').hide();
              }
            }
        });
        $(window).resize(function(){
          if ($(window).width() < 1280) {
            if (scroll > 2) {
              $('.nav-logo-item').show();
              $('.header-logo').css('display', 'inline-block');
            } else {
              $('.header-logo').hide();
              $('.nav-logo-item').removeClass('force_none');
              $('.nav-logo-item').show();
            }
          } else {
            if (scroll > 2) {
              $('.nav-logo-item').show();
              $('.header-logo').show();
            } else {
              $('.nav-logo-item').hide();
            }
          }
        });
});